import React from 'react';
import './AutorisationsUrb.css';

const AutorisationsUrb= () => {
    return (
        <div className='meres1'>

        <div className='container111'>
            

                <h2>Autorisations d'urbanisme</h2>
     
            </div>
            
           <div className='texte3a'>
            <p>

            Bienvenue dans la rubrique Autorisations d'Urbanisme de la Mairie du 2ᵉ Arrondissement de Port-Gentil. Ce service est
destiné à accompagner les citoyens et les professionnels dans leurs projets de construction ou de rénovation. Vous
trouverez ici toutes les informations nécessaires sur les démarches à suivre pour obtenir un permis de construire,
une déclaration préalable de travaux, un permis d’aménager, ou tout autre type d’autorisation d’urbanisme. Que vous
souhaitiez construire, rénover, ou aménager, notre équipe est à votre disposition pour vous guider dans vos demandes
et s’assurer que vos projets respectent les règles d'urbanisme en vigueur.

            </p>
           </div>
    </div>
    
    );
};

export default AutorisationsUrb;
